import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	error: {
		id: 'growth.inline-invite.error-panel.error',
		description: 'General error message. Endpoint returns failure response.',
		defaultMessage:
			"We can't invite {count, plural, one {this person} other {these people}} right now. Share this page with them instead.",
	},
	partialSuccess: {
		id: 'growth.inline-invite.error-panel.partial-success',
		description: 'Partial success message. Preceeds growth.inline-invite.error-panel.partial-error',
		defaultMessage:
			'Invitation sent to {count, plural, one {<bold>{email}</bold>} =2 {<bold>{email}</bold> and 1 other} other {<bold>{email}</bold> and {others} others}}.',
	},
	partialError: {
		id: 'growth.inline-invite.error-panel.partial-error',
		description: 'Partial error message. Follows growth.inline-invite.error-panel.partial-success',
		defaultMessage:
			"We couldn't invite <bold>{count, plural, one {1 other} other {# others}}</bold>. Share this page with them instead.",
	},
	maxInvites: {
		id: 'growth.inline-invite.error-panel.max-invites',
		description: 'Max invites message. Endpoint returns max invites response.',
		defaultMessage: 'You can invite a maximum of {max} people at one time',
	},
});

export default messages;
